import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "./AuthProvider";

function AdminRoute() {
    const { isBooting, isAdmin } = useAuth();
    const location = useLocation();

    if (isBooting) {
        return null;
    }

    if (!isAdmin) {
        return <Navigate to="/" replace state={{ from: location.pathname }} />;
    }

    return <Outlet />;
}

export default AdminRoute;
